module.exports = __webpack_public_path__ + "static/media/17UN-Women8.2f46f6e6.jpg";